import { hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities';
import axios from 'axios';
import React, { Component } from 'react';
import { Pie } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { setAlarm } from '../../../../redux/actions/general';
import { CsvExportFromApiButton, Spinner } from '../../../common';

import { CardTitle, Col, Row } from 'reactstrap';

import { filtersChanged, timespanOrIntervalChanged } from '../../../../redux/selectors/comparing';

import { PropTypes } from 'prop-types';
import storePropTypes from '../../../../redux/store/propTypes';

import { chartjsColors, pieZoomChartOptions } from '../../../../constants/chartjs';
import { H5LIVE_VIEW } from '../../../../constants/general';
import { playbackViewConfig, PLAYBACK_VIEW_NAMES } from '../playbackViews';
import {
   CenteredMsgShowing,
   ChartWrapper,
   HeightSetContainer,
   SetChartHeight,
   SimpleFlexItem,
   SimpleFlexRow,
   TwoSideFlexContainer,
   WidgetBodyContainer,
   WidgetContainer,
   WidgetHeaderContainer,
} from '../../../../styledComponents/styledComponents';
import ComponentTools from '../../../../util/ComponentTools';

import { getUnifiedErrorObject } from '../../../../util/ErrorUnifier';
import { PLAYTIME_BREAKDOWN } from '../../../zoom/ZoomConstants';
import ZoomHint from '../../../zoom/ZoomHint';
import Modal from '../../../zoom/templates/DefaultTemplate';
import { format_time_Number } from '../../../../util/NumberFormatter';

const mapStateToProps = (state) => {
   return state.general;
};

const mapDispatchToProps = { setAlarm };

let requestForData = false;

class PlaytimeBreakdown extends Component {
   constructor(props) {
      super(props);

      this.state = {
         loading: false,
         data: {
            grouping: 'OS',
            labels: [],
            datasets: [{}],
            rawTerms: [],
         },
         modal: {
            toggleShow: false,
            selectedTerm: '',
         },
         error: '',
         noData: false,
         chartOptions: pieZoomChartOptions(),
         url: '',
         header: {},
         cancelToken: null,
      };
      this.chartRef = React.createRef();
   }

   componentDidMount() {
      requestForData = true;
   }

   async componentWillReceiveProps(nextProps, nextContext) {
      if (
         timespanOrIntervalChanged(this.props, nextProps) ||
         filtersChanged(this.props, nextProps) ||
         nextProps.data.grouping !== this.state.data.grouping ||
         requestForData
      ) {
         requestForData = false;
         if (nextProps.data.grouping !== '') {
            await this.setState({
               ...this.state,
               data: {
                  ...this.data,
                  grouping: nextProps.data.grouping,
               },
            });
         }

         this.getData(
            nextProps.timespan,
            nextProps.filter,
            this.state.data.grouping,
            nextProps.cancelToken,
            nextProps.view,
         );

         const newChartOptions = { ...this.state.chartOptions };
         newChartOptions['onClick'] = (event, item) => {
            if (item.length === 0) {
               return;
            }
            const { _index } = item[0];
            const rawTermsLength = this.state.data.rawTerms.length;

            if (rawTermsLength <= _index) {
               return;
            }

            this.setState({
               modal: {
                  ...this.state.modal,
                  selectedTerm: this.state.data.rawTerms[_index],
                  toggleShow: true,
               },
            });
         };
         this.setState({
            ...this.state,
            chartOptions: newChartOptions,
         });
      }
   }

   getData(timespan, filter, group, cancelToken, view) {
      this.setState({
         ...this.state,
         loading: true,
         error: '',
         noData: false,
      });

      const self = this;

      const headerObj = ComponentTools.getHttpHeader(filter);
      const urlFilterQuery = ComponentTools.getFilterQueryParams(filter, view);

      const url = `/v2/${view}/playtime/${group}?from=${timespan.gte.format()}&to=${timespan.lt.format()}${urlFilterQuery}`;

      axios
         .get(url, {
            headers: headerObj,
            cancelToken: cancelToken.token,
         })
         .then(function (res) {
            const response = res.data;
            let datasets = [
               {
                  label: 'Views',
                  borderWidth: 1,
                  hidden: false,
                  backgroundColor: [],
                  borderColor: [],
                  data: [],
                  labels: [],
               },
            ];
            let noData = false;
            const rawTerms = [];

            if (res.status !== 204) {
               let buckets = response.data;

               noData = response.statusCode === 2000;

               buckets.forEach((bucket, idx) => {
                  const { key, totalPlaytime, playtimeProportion } = bucket;
                  const playtime = totalPlaytime.seconds;
                  const percentage = playtimeProportion.percent;

                  datasets[0].backgroundColor.push(hexToRgba(chartjsColors[idx], 25));
                  datasets[0].borderColor.push(chartjsColors[idx]);

                  rawTerms.push(key);

                  // cut off long label names, arbritary limit, at least allow string "Microsoft Internet Explorer"
                  const labelName = key.length > 30 ? `${key.substring(0, 27)}...` : key;

                  datasets[0].data.push(playtime);
                  datasets[0].labels.push(
                     `${labelName} ( ${percentage < 0.1 ? '<0.1' : percentage}%  |  ${format_time_Number(playtime)} )`,
                  );
               });
            }

            self.setState({
               ...self.state,
               loading: false,
               noData,
               data: {
                  ...self.state.data,

                  labels: datasets[0].labels,
                  datasets,
                  rawTerms,
               },
               url,
               header: headerObj,
               cancelToken,
            });
         })
         .catch(function (error) {
            if (error instanceof axios.Cancel) {
               return;
            }
            const errorObject = getUnifiedErrorObject(error);
            self.props.setAlarm('danger', errorObject);

            self.setState({
               ...self.state,
               data: {
                  ...self.state.data,

                  labels: [],
                  datasets: [{}],
               },
               loading: false,
               error: errorObject.message,
            });

            if (process.env.NODE_ENV === 'development') {
               console.error('error :', error);
            }
         });
   }

   render() {
      const errorOrNoData = this.state.error || this.state.noData;
      const { label, csvPrefix, zoomSettings } = playbackViewConfig(this.props.view);
      const issueMsg = this.state.error ? this.state.error : 'No data available';

      const { toggleShow, selectedTerm } = this.state.modal;
      const { url, header, cancelToken } = this.state;

      return (
         <WidgetContainer>
            <WidgetHeaderContainer>
               <HeightSetContainer $heightInPx={23}>
                  <TwoSideFlexContainer>
                     <SimpleFlexRow>
                        <SimpleFlexItem>
                           <CsvExportFromApiButton
                              url={url}
                              header={header}
                              cancelToken={cancelToken}
                              filename={`${csvPrefix}_PlaybacksPer${this.state.data.grouping}`}
                           />
                        </SimpleFlexItem>
                     </SimpleFlexRow>
                     <SimpleFlexRow>
                        <SimpleFlexItem>
                           <ZoomHint />
                        </SimpleFlexItem>
                     </SimpleFlexRow>
                  </TwoSideFlexContainer>
               </HeightSetContainer>
            </WidgetHeaderContainer>
            <WidgetBodyContainer>
               <Row>
                  <Col>
                     <CardTitle className='mb-0'>
                        {label} playtime per {this.state.data.grouping}
                     </CardTitle>
                     <div className='small text-muted'>
                        {`${this.props.timespan.title}\u00A0\u00A0\u00A0( UTC time )`}
                     </div>
                  </Col>
               </Row>
               <ChartWrapper className='chart-wrapper' marginTopPx={20} height={this.props.height}>
                  <Spinner loading={this.state.loading} parentTopMarginPx={60}>
                     {errorOrNoData ? (
                        <CenteredMsgShowing height={this.props.height}>{issueMsg}</CenteredMsgShowing>
                     ) : (
                        <SetChartHeight height={this.props.height}>
                           <Pie
                              ref={this.chartRef}
                              options={this.state.chartOptions}
                              data={this.state.data}
                              height={this.props.height}
                           />
                        </SetChartHeight>
                     )}
                  </Spinner>
               </ChartWrapper>
            </WidgetBodyContainer>
            {toggleShow && (
               <Modal
                  group={this.props.data.grouping.toLowerCase()}
                  term={selectedTerm}
                  timespan={{ start: this.props.timespan.gte, end: this.props.timespan.lt }}
                  metric={PLAYTIME_BREAKDOWN}
                  closeModal={() =>
                     this.setState({
                        modal: {
                           ...this.state.modal,
                           toggleShow: false,
                        },
                     })
                  }
                  settings={zoomSettings}
               />
            )}
         </WidgetContainer>
      );
   }
}

PlaytimeBreakdown.propTypes = {
   view: PropTypes.oneOf(PLAYBACK_VIEW_NAMES),
   filter: storePropTypes.filter,
   timespan: storePropTypes.timespan,
   cancelToken: storePropTypes.cancelToken,
   data: PropTypes.exact({
      grouping: PropTypes.string,
   }),
   setAlarm: PropTypes.func,
};

PlaytimeBreakdown.defaultProps = { view: H5LIVE_VIEW };

export default connect(mapStateToProps, mapDispatchToProps)(PlaytimeBreakdown);
